type ShortcutKeyboardEvent = Pick<
  KeyboardEvent,
  'repeat' | 'altKey' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'code' | 'target'
>;

const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"], [role="textbox"]';

export const isMacPlatform = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const platform = navigator.userAgentData?.platform || navigator.platform;
  return /mac|iphone|ipad|ipod|ios/i.test(platform);
};

export const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;

  return target.isContentEditable || Boolean(target.closest(EDITABLE_SELECTOR));
};

/** ⌘⇧F on Apple platforms, Ctrl+Shift+F elsewhere; ignored while typing or on key repeat. */
export const isFilterShortcutEvent = (event: ShortcutKeyboardEvent, isMac: boolean): boolean => {
  if (event.repeat || event.altKey || !event.shiftKey || event.code !== 'KeyF') return false;
  if (isEditableTarget(event.target)) return false;

  return isMac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;
};

export const getFilterShortcutAriaKeys = (isMac: boolean): string =>
  isMac ? 'Meta+Shift+F' : 'Control+Shift+F';

export const getFilterShortcutMessageId = (isMac: boolean): string =>
  isMac ? 'filterDropdown.shortcut.mac' : 'filterDropdown.shortcut.default';
